import { Routes } from '@angular/router'
import { AppKeycloakGuard } from './guard/app.keycloakguard'

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'rules',
    pathMatch: 'full',
  },
  {
    path: 'about',
    canActivate: [AppKeycloakGuard],
    loadChildren: () =>
      import('./features/about/about.module').then((m) => m.AboutModule),
  },
  {
    path: 'rules',
    canActivate: [AppKeycloakGuard],
    loadChildren: () =>
      import('./features/feature-rules/rules.module').then(
        (m) => m.RulesModule,
      ),
  },
  {
    path: '**',
    redirectTo: 'rules',
  },
]
